import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { PolazniciPopisService } from './polaznici-popis.service';
import { PartneriPopisService } from './../partneri-popis/partneri-popis.service';

import * as toastr from 'toastr';
import { PolaznikPopis } from './polaznici-popis';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
  selector: 'app-polaznici-popis',
  templateUrl: './polaznici-popis.component.html',
  styleUrls: ['./polaznici-popis.component.css'],
  providers: [PolazniciPopisService, PartneriPopisService]
})
export class PolazniciPopisComponent implements OnInit {

  sviPolaznici: PolaznikPopis[] = [];
  polaznikOptions: DataTables.Settings = {};
  polaznikTrigger: Subject<PolaznikPopis> = new Subject();

  polaznikForma: FormGroup;
  polaznikEditForma: FormGroup;

  sviPartneri: any[];

  constructor(
    private _fb: FormBuilder,
    public _partneriPopisService: PartneriPopisService,
    private _polazniciPopisService: PolazniciPopisService,
    public _router: Router,
    private _sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.dohvatiPopisPolaznika();
    this.partneriPopis();
    //Tablica početak
    this.polaznikOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
          targets: 'no-sort',
          orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj
    this.polaznikForma = this._fb.group({
      imeprezime: [''],
      spol: [''],
      oib: [''],
      email: [''],
      telefon: [''],
      adresa: [''],
      mjesto: [''],
      partnerId: [''],
      partnerNaziv: [''],
      aktivan: ['']
    });
    this.polaznikEditForma = this._fb.group({
      imeprezime: [''],
      spol: [''],
      oib: [''],
      email: [''],
      telefon: [''],
      adresa: [''],
      mjesto: [''],
      partnerId: [''],
      partnerNaziv: [''],
      aktivan: ['']
    });
  }

  pripremiPodatke(polaznik){
    // console.log(polaznik);
    this.polaznikEditForma = this._fb.group({
      id: polaznik['id'],
      imeprezime: polaznik['imeprezime'],
      spol: polaznik['spol'],
      oib: polaznik['oib'],
      email: polaznik['email'],
      telefon: polaznik['telefon'],
      adresa: polaznik['adresa'],
      mjesto: polaznik['mjesto'],
      partnerId: polaznik['partnerId'],
      partnerNaziv: polaznik['partnerNaziv'],
      aktivan: polaznik['aktivan']
    });
  }

  urediPolaznika(polaznik){
    // console.log(polaznik);
    let objektZaSlanje = {
      'id': polaznik['id'],
      'spol': parseInt(polaznik['spol']),
      'imeprezime': polaznik['imeprezime'],
      'oib': polaznik['oib'],
      'email': polaznik['email'],
      'telefon': polaznik['telefon'],
      'adresa': polaznik['adresa'],
      'mjesto': polaznik['mjesto'],
      'partner': polaznik['partnerId'],
      'aktivan': parseInt(polaznik['aktivan'])
    }
    // console.log(objektZaSlanje);
    this._polazniciPopisService.polaznikUredi(objektZaSlanje).subscribe(res => {
      console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        $('#polazniciTablica').DataTable().destroy();
        this.dohvatiPopisPolaznika();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  spremiPolaznika(polaznikForma){
    let objektZaSlanje = {
      'imeprezime': polaznikForma['imeprezime'],
      'spol': polaznikForma['spol'],
      'oib': polaznikForma['oib'],
      'email': polaznikForma['email'],
      'telefon': polaznikForma['telefon'],
      'adresa': polaznikForma['adresa'],
      'mjesto': polaznikForma['mjesto'],
      'partner': polaznikForma['partnerId']
    };
    if(polaznikForma['imeprezime'] && polaznikForma['spol']){
      this._polazniciPopisService.noviPolaznik(objektZaSlanje).subscribe(res => {
        if(res.success == true){
          toastr.success("Uspješno dodan polaznik!");
          $('#polazniciTablica').DataTable().destroy();
          this.dohvatiPopisPolaznika();
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    } 
  }

  dohvatiPopisPolaznika(){
    this.sviPolaznici = [];
    this._polazniciPopisService.dohvatiPolaznike({'idkorisnik': localStorage.getItem('userId'), 'admin': localStorage.getItem('vrsta')}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviPolaznici.push({
            'id': res.data[i]['idkorisnik'],
            'imeprezime': res.data[i]['ko_imeiprezime'],
            'spol': res.data[i]['ko_spol'],
            'oib': res.data[i]['ko_oib'],
            'email': res.data[i]['ko_email'],
            'telefon': res.data[i]['ko_telefon'],
            'adresa': res.data[i]['ko_adresa'],
            'mjesto': res.data[i]['ko_grad'],
            'partnerId': res.data[i]['partner_idpartner'],
            'partnerNaziv': res.data[i]['pa_nazivtvrtke'],
            'aktivan': res.data[i]['ko_aktivan']
          });
        }
        this.polaznikTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje popisa polaznika!");
      }
    });
  }
  
  //Autocomplete
  partneriPopis(){
    this.sviPartneri = [];
    this._partneriPopisService.dohvatiPartnere({}).subscribe(res => {
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.sviPartneri.push({
            'id': res.data[i]['idpartner'],
            'nazivtvrtke': res.data[i]['pa_nazivtvrtke'],
            'oib': res.data[i]['pa_oib'],
            'email': res.data[i]['pa_email'],
            'telefon': res.data[i]['pa_telefon'],
            'ulica': res.data[i]['pa_ulica'],
            'grad': res.data[i]['pa_grad'],
            'aktivan': res.data[i]['pa_aktivan']
          });
        }
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  autocompleListFormatter = (data: any) : SafeHtml => {
    let html = `<span>${data.nazivtvrtke}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  traziPartnera(e){
    this.polaznikForma.value.partnerId = e.id;
  }

  traziPartneraEdit(e){
    this.polaznikEditForma.value.partnerId = e.id;
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/polaznici-popis/polaznici-popis.component.ts